import styled from 'styled-components'

export const HelperText = styled.span<{ $hasError?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-size-5xs);
  font-size: var(--font-size-sm);
  color: var(--color-${(props) => (props.$hasError ? 'feedback-danger-300' : 'neutral-600')});

  & > i {
    display: ${(props) => (props.$hasError ? 'inline-block' : 'none')};
    height: 16px;
  }
`
